var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-to-top",class:{ active: _vm.isActive }},[_c('button',{on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fas fa-angle-up"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }